import React, {Component} from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import {resolveExposuresOverlap} from 'helpers/exposure';
import Action from 'components/organisms/nhl-team-stacking/actions';

class StackTeamsExposure extends Component {
    constructor(props) {
        super(props);
        const {stacking, stackNumber} = props;
        this.state = {
            min: stacking.getStackTeamsMinExposureByStackNumber(stackNumber),
            max: stacking.getStackTeamsMaxExposureByStackNumber(stackNumber),
        };
        this.isValueBeingChanged = {
            min: false,
            max: false,
        };
    }

    onChange(exposureType, value) {
        this.isValueBeingChanged[exposureType] = true;
        this.setState({[exposureType]: value});
    }

    onBlur(exposureType, value) {
        const exposure = this.getUpdatedExposure(exposureType, value);

        this.setState({...exposure});

        this.isValueBeingChanged[exposureType] = false;

        this.props.dispatch(Action.setStackTeamsExposureForStackNumber(exposure, this.props.stackNumber));
    }

    getUpdatedExposure(exposureType, value) {
        const limitValue = 'min' === exposureType ? 0 : 100;
        const oppositeType = 'min' === exposureType ? 'max' : 'min';
        const currentExposure = {
            min: this.getActualValue('min'),
            max: this.getActualValue('max'),
        };
        currentExposure[exposureType] = NumberHelper.prepareInt(value, limitValue).limitByRange(0, 100, 0, 100).get();

        const updatedExposure = resolveExposuresOverlap(currentExposure, exposureType);

        if (currentExposure[oppositeType] === updatedExposure[oppositeType]) {
            delete updatedExposure[oppositeType];
        }

        return updatedExposure;
    }

    getActualValue(exposureType) {
        let value = this.state[exposureType];
        if (!this.isValueBeingChanged[exposureType]) {
            const {stackNumber, stacking} = this.props;
            value = stacking.getStackTeamsExposureByTypeAndStackNumber(exposureType, stackNumber);
        }
        return value;
    }

    render() {
        const exposureMin = this.getActualValue('min');
        const exposureMax = this.getActualValue('max');

        return [
            <div key={0} className="percent-in">
                <input
                    type="number"
                    min="0"
                    max="100"
                    className="form-control input-sm"
                    value={`${exposureMin}`}
                    onChange={(e) => ::this.onChange('min', e.target.value)}
                    onBlur={(e) => ::this.onBlur('min', e.target.value)}
                />
                <span className="percent">%</span>
            </div>,
            <div key={1} className="percent-in">
                <input
                    type="number"
                    min="0"
                    max="100"
                    className="form-control input-sm"
                    value={`${exposureMax}`}
                    onChange={(e) => ::this.onChange('max', e.target.value)}
                    onBlur={(e) => ::this.onBlur('max', e.target.value)}
                />
                <span className="percent">%</span>
            </div>,
        ];
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(StackTeamsExposure);
